import React, { useEffect, useState, useCallback } from "react";
import { useParams } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Sidebar from "./Sidebare";
import { useAuth } from "../contexts/AuthContext";
import { Avatar, Box, Button, Typography, Tab, Tabs, Card, CardContent, CardMedia, IconButton,
   TextField, Menu, MenuItem, useMediaQuery } from "@mui/material";
import EuroIcon from '@mui/icons-material/Euro';
import VerifiedIcon from '@mui/icons-material/Verified';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { PhotoCamera } from '@mui/icons-material';
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { formatDistanceToNow } from "date-fns";
import fr from "date-fns/locale/fr";
import LikeButton from "../components/LikeButton";
import FollowButton from "../components/FollowButton";
import PostDescription from "../components/PostDescription";
import DeletionModal from "../components/DeletionModal";
import News from "../components/News";
import api from "../api/api";
import { updateUserProfile } from "../api/api";
import "./Profile.css?v=1.0";  
import "./homePage.css?v=1.0";

const Profile = () => {
  const { user, updateUser } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const { universityId } = useParams(); 
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [publications, setPublications] = useState([]);
  const [university, setUniversity] = useState([]);
  const [programmes, setProgrammes] = useState([]);
  const [editingField, setEditingField] = useState(null);
  const [editProfile, setEditProfile] = useState(false);
  const [tempValue, setTempValue] = useState("");
  const [userData, setUserData] = useState(null);
  const [newFollower, setNewFollower] = useState(0);
  const isSmallScreen = useMediaQuery('(max-width:600px)');



  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pubResponse, progResponse, univResponse] = await Promise.all([
          api.get(`/publications/${universityId}`),
          api.get(`/programs/${universityId}`),
          api.get(`/universities/${universityId}`)
        ]);
  
        setPublications(pubResponse.data);
        setProgrammes(progResponse.data);
        setUniversity(univResponse.data);
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      }
    };
  
    // Vérifie si universityId existe avant de faire la requête
    if (universityId) {
      fetchData();
    }
  }, [universityId]);  // Ajout de universityId comme dépendance

  useEffect(() => {
    // Ensure university and user data are available before calculating isFollowing
    if (university && user) {
      setIsFollowing(Array.isArray(university.listAbonnements) && university.listAbonnements.includes(user._id));
      

    }
  }, [university, user]);  // Run whenever university or user changes
  
   

  const handleTabChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  const handleEdit = (field, value) => {
    setEditingField(field);
    setTempValue(value);
  };
  // ouvrir les boutons pour editer les infos user
  const handleEditProfile = () => {

    setEditProfile(!editProfile);
    
  }

  const handleSave = async (field, imageData = null) => {
    try {
      const formData = new FormData();

      if (imageData) {
        // ✅ Cas d'une image (photo ou coverPhoto)
        formData.append(field, imageData);
      } else {
        // ✅ Cas d'un champ texte (nom ou présentation)
        formData.append(field, tempValue);
      }

      const updatedData = await updateUserProfile(user._id, formData);

      // ✅ Mise à jour du contexte et de l'état local
      updateUser(updatedData.user);
      setUserData((prev) => ({ ...prev, ...updatedData.user }));
    } catch (error) {
      alert(error.message);
    } finally {
      setEditingField(null);
    }
  };

const handleImageChange = (event, field) => {
  const file = event.target.files[0];
  if (file) {
    handleSave(field, file); 
  }
};


// Fonction pour ouvrir le menu
const handleMenuOpen = (event, post) => {
  setAnchorEl(event.currentTarget);
  setSelectedItem(post);
};

// Fonction pour fermer le menu
const handleMenuClose = () => {
  setAnchorEl(null);
};

// Fonction pour modifier un post
const handleEditPost = () => {
  if (selectedItem) {
    console.log("Modifier le post :", selectedItem);
    // Ici, tu peux ouvrir un modal ou naviguer vers une page de modification
  }
  handleMenuClose();
};

// Fonction pour supprimer un post
const handleDeletePost = () => {
  if (selectedItem) {
    // Ouvrir le modal de confirmation pour la suppression

    handleOpenModal(selectedItem, "post");
  }
  handleMenuClose();
};

// Fonction pour supprimer un post
const handleDeleteProgram = () => {
  if (selectedItem) {
    // Ouvrir le modal de confirmation pour la suppression

    handleOpenModal(selectedItem, "programme");
  }
  handleMenuClose();
};


// Supprimer un Programme ou une Publication
const handleDeleteItem = async (item) => {
  try {
    // Appel API pour supprimer le post/programme
    if (itemType === "post") {
      await api.delete(`/publications/${item._id}`);
      setPublications((prev) => prev.filter((p) => p._id !== item._id)); // Mise à jour de l'état local pour les publications
    } else if (itemType === "programme") {
      await api.delete(`/programs/${item._id}`);
      setProgrammes((prev) => prev.filter((p) => p._id !== item._id)); // Mise à jour de l'état local pour les programmes
    }
    setOpenModal(false); // Ferme le modal après suppression
  } catch (error) {
    console.error("Erreur de suppression:", error);
    alert("Une erreur s'est produite lors de la suppression.");
  }
};




const handleOpenModal = (item, type) => {
  setSelectedItem(item);
  setItemType(type); // Définir le type d'élément à supprimer
  setOpenModal(true);
};

const handleCloseModal = () => {
  setOpenModal(false);
};

// Fonction pour inverser la valeur de `isFollowing`
const switchIsFollowing = () => {
  setIsFollowing((prev) => !prev);
  if(university.listAbonnements?.length == 0) {
    setNewFollower(!isFollowing ? 1 : 0);
  }else {
    setNewFollower(!isFollowing ? 0 : -1);
  }
};


  const cardStyles = {
    postActions: {
      display: "flex",
      alignItems: "center",
      gap: "16px"
    },
    infoText: {
      color: "#6c757d",
      fontSize: "0.875rem"
    },
    image: {
      width: "100%",
      height: "auto",
      borderRadius: "8px",
    }
  };

  return (
    <Box display="flex">
      <Sidebar userProfile={user} />

      {/* Modal de confirmation */}
      <DeletionModal 
        open={openModal} 
        onClose={handleCloseModal} 
        onDelete={handleDeleteItem} 
        type={itemType} 
        item={selectedItem} 
      />
      <Box className="profile-container">

          <Box className="scrollable-content">

    {/* Cover Photo avec bouton d'édition */}
    <Box 
      className="cover-photo" 
      style={{
        backgroundImage: `url(${university.coverPhoto || "https://ega-senegal.com/uploads/cover_default.jpeg"})`,
        position: "relative",  // Ajout de cette propriété pour positionner le bouton au sein de la boîte
        height: "200px"  
      }}
    >
      {editProfile ? 
      (
      <IconButton component="label" color="primary" sx={{
          background: "white",
          position: "absolute", 
          bottom: "10px", 
          right: "10px",  
          padding: "8px",  
        }} >
              <PhotoCamera />
              <input hidden type="file" accept="image/*" onChange={(event) => handleImageChange(event, 'coverPhoto')}  />
      </IconButton> ): ""}
    </Box> 


    {/* Profile Info */}
    <Box className="profile-info">
      <Box position="relative">
        <Avatar src={university.photo ? university.photo : "https://ega-senegal.com/uploads/photo_default.jpg"} className="profile-avatar" sx={{ width: 100, height: 100 }} />

        {editProfile? (
          <IconButton component="label" color="primary" sx={{
            background: "white",
            position: "absolute", 
            bottom: "10px", 
            right: "-10px", 
            padding: "8px", 
          }} >
                <PhotoCamera />
                <input hidden type="file" accept="image/*" onChange={(event) => handleImageChange(event, 'photo')}  />
        </IconButton>
        ): ""}

      </Box>

      {isSmallScreen ? ("") : (
        <Box className="profile-stats">
          <Box className="profile-stat">
            <Typography variant="h6">{publications.length || 0}</Typography>
            <span>Publications</span>
          </Box>
          <Box className="profile-stat">
            <Typography variant="h6"> {university.listAbonnements ? (university.listAbonnements.length + newFollower) : (newFollower)} </Typography>
            <span>Abonnés</span>
          </Box>
          <Box className="profile-stat">
            <Typography variant="h6"> {programmes.length || 0} </Typography>
            <span>Programmes</span>
          </Box> 
          {/* Button to modify the profile  */}         
          {(user?._id === universityId) && (
            <Button variant="contained" size="small" onClick={handleEditProfile}>
              {editProfile ? "Valider" : "Modifier le Profil"}
            </Button>
          )}

       </Box>
      )}

    </Box>

    {isSmallScreen && (
      <Box className='profile-info'>
        <Box className="profile-stats">
        <Box className="profile-stat">
          <Typography variant="h6">{publications.length || 0}</Typography>
          <span>Publications</span>
        </Box>
        <Box className="profile-stat">
          <Typography variant="h6"> {university.listAbonnements ? (university.listAbonnements.length + newFollower) : (newFollower)} </Typography>
          <span>Abonnés</span>
        </Box>
        <Box className="profile-stat">
          <Typography variant="h6"> {programmes.length || 0} </Typography>
          <span>Programmes</span>
        </Box>
        </Box>
     </Box>
    )}

    {/* Name and Bio */}
    <Box className="profile-bio">
      
      {/* Nom avec bouton d'édition */}
      <Box display="flex" alignItems="center" gap={1}>
        {editingField === "name" ? (
          <TextField
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            variant="outlined"
            size="small"
            onBlur={() => handleSave("name")}
            autoFocus
          />
        ) : (
          <>
            
            <Typography variant="h6">{university.name || "Utilisateur"}
            <VerifiedIcon style={{ color: "#27aae0", fontSize: "15px" }}  />
            </Typography>
            {editProfile? (
              <Button
              size="small"
              onClick={() => handleEdit("name", university.name)}
            >
              <EditIcon fontSize="small" />
            </Button>
            ): ""}
          </>
        )}

        {(isSmallScreen && user) ? user._id === universityId && (
        <Button variant="contained" size="small" onClick={handleEditProfile}>
          {editProfile ? "Valider" : "Modifier le Profil"}
        </Button>
        ): ""}
        {user ? user._id !== universityId && (
          <FollowButton
          universityId={universityId}
          isFollowing={isFollowing}
          onClick={switchIsFollowing}
        />
        ) : ""}

      </Box>

      {/* Présentation avec bouton d'édition */}
      <Box display="flex" alignItems="center" gap={1}>
        {editingField === "presentation" ? (
          <TextField
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            multiline
            onBlur={() => handleSave("presentation")}
            autoFocus
          />
        ) : (
          <>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', textAlign: 'justify', textJustify: 'inter-word', hyphens: 'auto' }}>
              {university.presentation || "Vous pouvez ajouter une présentation de l'université"}
            </Typography>
            {editProfile? (
              <Button size="small" onClick={() => handleEdit("presentation", university.presentation)}>
              <EditIcon fontSize="small" />
            </Button>
            ): ""}
          </>
        )}
      </Box>
      
    </Box>

    {/* Main Content */}
    <Box>
      
      <Tabs 
        value={tabValue} 
        onChange={handleTabChange} 
        className="tabs-for-profile" 
        TabIndicatorProps={{ style: { background: "#27aae0" } }}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Tab label="Publications" sx={{ flex: 1, textAlign: "center" }} />
        <Tab label="Programmes" sx={{ flex: 1, textAlign: "center" }} />
      </Tabs>

      <Box className="scrollable-content">
        {tabValue === 0 && (
          publications.length > 0 ? (
          publications.map((post) => (
            <Card key={post._id} className="publication-card" sx={{ position: "relative" }} >

            <CardContent>
              {/* Bouton menu trois points en haut à droite */}
              {user ? user._id === universityId && (
              <IconButton 
                onClick={(event) => handleMenuOpen(event, post)} 
                sx={{ position: "absolute", top: 8, right: 8 }}
              >
                <MoreVertIcon  />
              </IconButton>):""}

              {/* Menu déroulant */}
              <Menu anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              >
                <MenuItem onClick={handleEditPost}>Modifier</MenuItem>
                <MenuItem onClick={handleDeletePost}>Supprimer</MenuItem>
              </Menu>

              <PostDescription text={post.content} />
            
              <CardMedia component="img" image={post.attachments[0]} alt="Post Image" className="post-image" />
              
              <Box className="post-actions" style={cardStyles.postActions}>
                <Typography style={cardStyles.infoText}>
                  {formatDistanceToNow(new Date(post.createdAt), { addSuffix: true, locale: fr })}
                </Typography>
          
                <LikeButton post={post} updatePostLikes={(postId, change, likesCount) => {
                  setPublications((prev) => prev.map((p) =>
                    p._id === postId
                      ? { ...p, likes: likesCount !== undefined ? new Array(likesCount).fill("like") : [...p.likes, "like"].slice(0, p.likes.length + change) }
                      : p
                  ));
                }} />
              </Box>
            </CardContent>
          </Card>
          )
        )): (
          <Typography variant="h6" color="textSecondary" textAlign="center" sx={{ mt: 3, padding: "50px" }}>
            Aucune publication disponible pour le moment.
          </Typography>
        )
        )}

        {tabValue === 1 && (
          programmes.length > 0 ? (
            programmes.map((element) => (
              <Card key={element.id} className="programm-card" sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden", position: "relative" }}>
                
                <CardMedia
                  component="img"
                  image={element.attachments[0] || "default-image.jpg"} 
                  alt="Programme Image"
                  sx={{ height: 200, objectFit: "cover" }}
                />
                
                <CardContent>
                  {/* Nom de l'université et logo */}
                  <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <Avatar src={element.universityId.logo || "default-logo.png"} sx={{ width: 40, height: 40 }} />
                    <Typography variant="h6" fontWeight="bold">{element.title}</Typography>

                    {/* Bouton menu trois points en haut à droite */}
                    {user ? user._id === universityId && (
                    <IconButton 
                      onClick={(event) => handleMenuOpen(event, element)} 
                      sx={{ position: "absolute", right: 8 }}
                    >
                      <MoreVertIcon  />
                    </IconButton>):""}

                    {/* Menu déroulant */}
                    <Menu anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleEditPost}>Modifier</MenuItem>
                      <MenuItem onClick={handleDeleteProgram}>Supprimer</MenuItem>
                    </Menu>

                  </Box>

                  {/* Description */}
                  <Typography variant="body2" color="textSecondary" sx={{ textAlign: "justify", mb: 2 }}>
                    {element.description}
                  </Typography>

                  {/* Informations principales */}
                  <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={2} mb={2}>
                    <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PlaceOutlinedIcon color="primary" /> {element.universityId.address.city}, {element.universityId.address.country}
                    </Typography>
                    <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AccessTimeOutlinedIcon color="primary" /> {element.duration}
                    </Typography>
                    <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <EuroIcon color="primary" /> {element.price}
                    </Typography>
                  </Box>

                  {/* Bouton d'action */}
                  <Button 
                    className="button"
                    variant="contained" 
                    color="primary" 
                    fullWidth 
                    sx={{ borderRadius: 2, textTransform: "none", fontWeight: "bold" }}
                  >
                    S'inscrire
                  </Button>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography variant="h6" color="textSecondary" textAlign="center" sx={{ mt: 3, padding: "50px" }}>
              Aucun programme disponible pour le moment.
            </Typography>
          )
        )}

        
      </Box>
    </Box>

          </Box>
          
      </Box>

    

    <Box className="sidebar-right">
        <News />
      </Box>
  </Box>
  );
};

export default Profile;
